export const roleMenuMapping: { [roleId: string | number]: string[] } = {
  1: ['/role-region', '/lookups', '/mass-upload', '/approval-matrix', '/notification-matrix', '/approval-reassign', '/admin-claims'],
  2: ['/task-list', '/claim-list'],
  3: ['/task-list', '/claim-list'],
  4: ['/task-list', '/claim-list'],
  5: ['/task-list', '/claim-list'],
  6: ['/task-list', '/claim-list'],
  7: ['/task-list', '/claim-list'],
  8: ['/task-list', '/claim-list'],
  9: ['/task-list', '/claim-list'],
  10: ['/task-list', '/claim-list'],
  11: ['/task-list', '/claim-list'],
  12: ['/task-list', '/claim-list'],
  13: ['/task-list', '/claim-list'],
  14: ['/task-list', '/claim-list']
};

/**
 * All available menu routes in the application
 */
export const allMenuRoutes: string[] = [
  '/dm-sale-dashboard',
  '/role-region',
  '/lookups',
  '/mass-upload',
  '/approval-matrix',
  '/task-list',
  '/claim-list',
  '/admin-claims'
];

/**
 * Get allowed menu routes for a specific role ID
 */
export function getAllowedRoutesForRole(roleId: string | number | null): string[] {
  if (roleId === null) {
    return allMenuRoutes; // Show all routes if no role is selected
  }

  // Check if there's a specific mapping for this role
  if (roleId in roleMenuMapping) {
    return roleMenuMapping[roleId];
  }

  // Default: show all routes if role is not specifically mapped
  return allMenuRoutes;
}